<template>
  <div class="content-1">
    <div class="user">
      <div class="flag"></div>
      <div class="time"
        >适用时间：{{ durationTime.start }}-{{ durationTime.end }}</div
      >
      <div class="u-top">
        <img class="avatar" :src="info.userDetail.head_img" alt="" />
        <div class="">
          <div class="name-c">
            <div class="nickname">{{ info.userDetail.truename }}</div>
            <img class="gender" :src="genderImage" alt="" />
          </div>
          <div class="age">年龄段：{{ info.userDetail.age }}</div>
        </div>
      </div>
      <div class="u-bottom">
        <div class="b-item">
          <div class="b-item-text">健康综合得分</div>
          <div
            ><span class="bold">{{
              info.radarResult.comLevel.average_score || '-'
            }}</span
            >/100</div
          >
        </div>
        <div class="b-line"></div>
        <div class="b-item">
          <div class="b-item-text">综合健康水平</div>
          <div
            >超过了<span class="bold">{{
              info.radarResult.comLevel.scale || '-'
            }}</span
            >%同龄人</div
          >
        </div>
      </div>
    </div>
    <div class="rardar">
      <ResultChart ref="resultChart" :info="info" />
    </div>
    <img class="coach" :src="info.fatTargetResult.icon_url" alt="" />
  </div>
</template>
<script>
import ResultChart from '../radar.vue'
export default {
  components: {
    ResultChart
  },
  props: {
    info: {
      type: Object,
      default: null
    }
  },
  computed: {
    genderImage() {
      return this.info.userDetail.gender == '1'
        ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c81bcce4d5b028aeef10ffe7da2ddc90.png'
        : 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d35fed961a30b97e7d6e2df41a47f244.png'
    },
    durationTime() {
      let start = this.info.cnaNewResult.finish_time.replace(/-/g, '/')
      let startDate = new Date(start)
      let endTime = startDate.getTime() + 1000 * 60 * 60 * 24 * 7
      let endDate = new Date(endTime)
      return {
        start:
          startDate.getFullYear() +
          '.' +
          (startDate.getMonth() + 1) +
          '.' +
          startDate.getDate(),
        end:
          endDate.getFullYear() +
          '.' +
          (endDate.getMonth() + 1) +
          '.' +
          endDate.getDate()
      }
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.content-1 {
  padding-bottom: 20px;
  border-radius: 8px;
  overflow: hidden;
  background-color: #fff;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f14f6327da7af637c278ecde3ce31178.png');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center top;
}

.user {
  padding-top: 4px;
  position: relative;

  .time {
    padding: 0px 12px;
    text-align: right;
    font-size: 10px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 14px;
  }

  .u-top {
    display: flex;
    align-items: center;
    padding: 18px 20px 13px;

    .avatar {
      width: 54px;
      height: 54px;
      border-radius: 50%;
      overflow: hidden;
      border: 2px solid #ffffff;
      margin-right: 10px;
      box-sizing: border-box;
    }

    .name-c {
      display: flex;
      align-items: center;
      margin-bottom: 4px;

      .nickname {
        max-width: 200px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 25px;
        margin-right: 8px;
      }

      .gender {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        overflow: hidden;
        background: #ff8ba2;
      }
    }

    .age {
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 17px;
    }
  }

  .u-bottom {
    display: flex;
    align-items: center;
    height: 108px;
    box-sizing: border-box;
    padding: 12px 0px 42px;

    .b-line {
      width: 2px;
      height: 49px;
      background-color: rgba(255, 255, 255, 0.3);
    }

    .b-item {
      height: 100%;
      flex: 1;
      padding: 0px 10px;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 17px;
      text-align: center;

      .bold {
        height: 44px;
        font-size: 35px;
        font-family: DIN;
        font-weight: 500;
        color: #ffffff;
        line-height: 44px;
      }
    }
  }
}

.rardar {
}

.coach {
  width: 295px;
  background: #f5f4ff;
  border-radius: 8px;
  margin: 0 auto;
  object-fit: contain;
}
</style>
